export const STOCK_BALANCE = 'StockBalance';
//# sourceMappingURL=stock-balance.js.map